export const DARKCOUNTRY_ADDRESS = '0xc8c340cebd11f690';
export const DARKCOUNTRY_MARKET_ADDRESS = '0xc8c340cebd11f690';
export const FUNGIBLE_TOKEN_ADDRESS = '0xf233dcee88fe0abe';
export const FLOW_TOKEN_ADDRESS = '0x1654653399040a61';
export const NON_FUNGIBLE_TOKEN_ADDRESS = '0x1d7e57aa55817448';
